import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Toaster } from "react-hot-toast";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
const root = ReactDOM.createRoot(document.getElementById('root'));


const _wr = function(type) {
  const orig = window.history[type];
  return function() {
    const rv = orig.apply(this, arguments);
    const e = new Event(type.toLowerCase());
    window.dispatchEvent(e);
    return rv;
  };
};

window.history.pushState = _wr("pushState");
window.history.replaceState = _wr("replaceState");

root.render(
    <>
      <Toaster position="top-right" reverseOrder={false} />
    <App />
    </>
 
 
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegistration.register();
